export default __webpack_public_path__ + "static/media/arrows-from-line.7fc08211.svg";